import { createAction, props } from '@ngrx/store';
import { IVisiblePanels } from '../models/IVisiblePanels';
import { IView } from '../models/IView';
import { IViews } from '../models/IViews';

export const updateShownMerkmale = createAction(
  '[Panels] Update ShownMerkmale',
  props<{ merkmale: IVisiblePanels }>()
);

export const togglePanel = createAction(
  '[Panels] Toggle panel',
  props<{ selector: string }>()
);

export const showPanel = createAction(
  '[Panels] Show panel',
  props<{ selector: string }>()
);

export const hidePanel = createAction(
  '[Panels] Hide panel',
  props<{ selector: string }>()
);

export const addView = createAction(
  '[Panels] Add a new view',
  props<{ view: IView }>()
);

export const applyDefaultView = createAction(
  '[Panels] Copies the default view into the current view'
);

export const changeDefaultView = createAction(
  '[Panels] Changes the default view',
  props<{ viewName: string }>()
);

export const deleteNamedView = createAction(
  '[Panels] Deletes a named view',
  props<{ viewName: string }>()
);

export const applyNamedView = createAction(
  '[Panels] Applies a named view to the current',
  props<{ viewName: string }>()
);

export const setNamedViews = createAction(
  '[Panels] Sets the named views from API',
  props<{ views: IViews }>()
);

export const clearCurrentView = createAction(
  '[Panels] Clears the current view',
  props<{ showAllMerkmale: boolean; openAllPanels: boolean }>()
);

export const closeAllPanels = createAction(
  '[Panels] Close all panels'
);
